import { useToast } from "@/state/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/ui/components/ui/toast"
import {
  AlertCircle,
  AlertTriangle,
  CheckCircle2,
  Info,
  LoaderCircle,
} from "lucide-react"
import { createPortal } from "react-dom"

function ToastIcon({ variant }: { variant?: string }) {
  switch (variant) {
    case "success":
      return <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />
    case "destructive":
      return <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
    case "warning":
      return <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
    case "info":
      return <Info className="mt-0.5 h-4 w-4 shrink-0" />
    case "loading":
      return <LoaderCircle className="mt-0.5 h-4 w-4 shrink-0 animate-spin" />
    default:
      return null
  }
}

export function Toaster() {
  const { toasts } = useToast()

  if (typeof document === "undefined") {
    return null
  }

  return createPortal(
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        action,
        variant,
        ...props
      }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex gap-3">
              <ToastIcon variant={variant} />
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>,
    document.body
  )
}
